import React, { useEffect, useRef } from "react";
import { compose } from "redux";
import { useDispatch } from "react-redux";
import { Redirect } from "react-router";
import { useHistory, useLocation } from "react-router-dom";
import qs from "qs";
import withTranslations from "../../../../../hocs/withTranslations";
import withRegisterForm from "../../../../../hocs/withRegisterForm";
import {
  getLoginOtpWithAuthQueryUrl,
  isDisplayableToastMessage,
  resolvePostAuthRedirectPath
} from "../../../../../lib/auth/authRedirectUrl";
import { getRegisterOtpNavigationState } from "../../../../../lib/auth/loginOtpNavigationState";
import { actions as alertsActions } from "../../../../../redux/modules/alerts";
import AuthPageLayout from "../../../auth/AuthPageLayout";
import NewRegisterFormContent from "../../../auth/NewRegisterFormContent";
import InvisibleReCaptcha from "../../../common/InvisibleReCaptcha";

function NewRegisterPage({
  registerLoading,
  formBuilder,
  register: executeRegister,
  validationErrors,
  clearValidationError,
  userData,
  locale,
  translate
}) {
  const { search } = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const reCaptchaRef = useRef(null);
  const params = qs.parse(search, { ignoreQueryPrefix: true });

  useEffect(() => {
    if (isDisplayableToastMessage(params.toastMessage)) {
      dispatch(
        alertsActions.addInfoAlert({
          title: params.toastMessage,
          skipTranslation: true
        })
      );
    }
  }, [dispatch, params.toastMessage]);

  if (userData) {
    return <Redirect to={resolvePostAuthRedirectPath(search)} />;
  }

  const handleSubmit = async () => {
    const recaptcha = await reCaptchaRef.current?.executeAsync?.();

    if (!recaptcha) {
      return;
    }

    executeRegister({
      fields: formBuilder.fields,
      recaptcha,
      redirectTo:
        typeof params.redirectTo === "string" ? params.redirectTo : undefined,
      onSuccess: () => {
        history.push(
          getLoginOtpWithAuthQueryUrl({
            locale,
            returnUrl: params.redirectTo,
            toastMessage: params.toastMessage
          }),
          getRegisterOtpNavigationState(formBuilder.fields)
        );
      }
    });
  };

  return (
    <AuthPageLayout
      title={translate("auth_register-page_title")}
      subtitle={translate("auth_register-page_subtitle")}
    >
      <NewRegisterFormContent
        formBuilder={formBuilder}
        registerLoading={registerLoading}
        validationErrors={validationErrors}
        clearValidationError={clearValidationError}
        locale={locale}
        onSubmit={handleSubmit}
      />
      <InvisibleReCaptcha ref={reCaptchaRef} />
    </AuthPageLayout>
  );
}

export default compose(withTranslations, withRegisterForm)(NewRegisterPage);
